import React, { useState } from 'react';
import "./SignUp.css"
import { useNavigate } from 'react-router-dom';
import flashMessage from '../components/HelperFunctions';
import axios from 'axios';


function PasswordResetStart({ checkLogin, user }) {
  const [email, setEmail] = useState("");
  const [buttonClicked, setButtonClicked] = useState(false);
  const emailIsValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());

  const handleSubmit = async (e) => {
    e.preventDefault();

    
    try {
      const response = await axios.post(`${process.env.REACT_APP_BACKEND_HOST}/password-reset`, {
        email
      });
      if (response.status === 200) {
        setButtonClicked(true);
        flashMessage('success', 'Check your email for a link to reset your password');
      } else {
        flashMessage('error', 'Failed to reset password');
      }
    } catch (error) {
      if (error.response.status === 404) {
        flashMessage('error', 'Email not found');
      } else {
      flashMessage('error', 'Failed to reset password');
      }
    }

  }

  const navigate = useNavigate();

  return (
    <div>
      {user ? navigate('/overview') :
        <div className='page-content auth-page'>
          <div className="auth-intro"><span>Account security</span><h1>Let’s get you back in.</h1><p>We’ll send a secure reset link to the email address associated with your Sayable account.</p></div>
          <div className="signup-selection auth-card password-reset-start">
          <div className='page-title'>Reset your password</div>
          <p className="auth-card-subtitle">Enter your account email to receive a reset link.</p>
          {buttonClicked ? <div className='login-info'>Please check your email for a link to reset your password.</div> :
            (<form onSubmit={handleSubmit}>
                  <div className='signup-label'><span className='red'>*</span> Email <span className='label-note'>(required)</span></div>
                  <input className='user-email' type="email" autoComplete="email" required name="signup-email" value={email} id="signup-email" onChange={(e) => setEmail(e.target.value)} />

                  <button disabled={!emailIsValid} className='button signup-button' type="submit">Reset</button>
                </form>)}
          </div>
        </div>}
    </div>
  );
}

export default PasswordResetStart;
